export default {
  app: {
    golf: {
      title: 'Baaninformatie',
      hasEVChargingPoint: 'EV-laadpunt',
      hasCaddieService: 'Caddie-service',
      hasTrolley: 'Trolley',
      hasBuggy: 'Buggy',
      hasClubRental: 'Clubverhuur',
      hasAcademy: 'Academie',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA-certificering',
      hasTrainingArea: 'Oefengebied',
      hasRestaurant: 'Restaurant',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Honden op de baan',
      numberOfHoles: 'Aantal holes',
    },
  },
};
